import type { FC } from 'react'
import documents from '@/assets/images/emptyState.svg'
import { cn } from '@/helpers/utils'

interface EmptyStateListingsProps {
	title: string
	description: string
	action?: React.ReactNode
	className?: string
}

export const EmptyStateListings: FC<EmptyStateListingsProps> = ({
	title,
	description,
	action,
	className
}) => {
	return (
		<div
			className={cn(
				'flex flex-col items-center justify-center gap-4',
				className
			)}
		>
			<div className='relative flex justify-center'>
				<img
					alt={title}
					className='relative z-2'
					height={64}
					src={documents}
					width={64}
				/>
				<span className='absolute -top-5 z-1 size-19 rounded-full bg-neutral-100' />
			</div>
			<div className='flex max-w-100 flex-col items-center text-center'>
				<p className='font-bold text-lg text-neutral-900'>{title}</p>
				{description && (
					<p className='text-md text-neutral-700'>{description}</p>
				)}
			</div>
			{action && action}
		</div>
	)
}
